import { PresenceState } from 'src/contexts/chat-context';
import { Coach, Member } from 'src/models/Common';

export interface Conversation {
  uuid: string;
  member: Member;
  coach: Coach;
  active: boolean;
  kind?: PresenceState; // we check for this for live coaching, if its live coach we show some match by live coaching under name of the person
  newestMessage?: Message;
  myNewestMessage?: Message;
  createdAt: any;
  oldMatchNotContacted?: boolean;
  lastActivityTimestamp?: any;
  oldestMessageUuid?: string;
  isNewMatch?: boolean;
  isMatchedOverFiveDaysAgo: boolean;
}

export interface ConversationEdge {
  cursor: string;
  node: Conversation;
}

export interface ConversationsQueryResult {
  conversations: {
    edges: ConversationEdge[];
    pageInfo: ConversationsPageInfo;
  };
}

export interface ConversationsPageInfo {
  endCursor: string;
  hasNextPage: boolean;
}

export interface ConversationsQueryVars {
  first?: number;
  before?: string;
  after?: string;
  orderBy?: string;
  uuid?: string;
  active?: boolean;
  providerUuid?: string;
  memberUuid?: string;
  memberName?: string;
  memberEmail?: string;
  memberCompany?: string;
}

export interface MessagesQueryVars {
  after?: string;
  conversationUuid: string;
}

export interface MessagesPageInfo {
  oldestMessageUuid: string;
  conversationUuid: string;
}

export interface MessagesQueryResult {
  getMessages: {
    messages: Message[];
    pageInfo: MessagesPageInfo;
  };
}

export interface MessageResource {
  uuid: string;
  order: number;
  meditationId?: number | null;
  programId?: number | null;
  companyAdditionalBenefitId?: number | null;
}

export enum FetchStatus {
  NotStarted = 'NOT_STARTED',
  Loading = 'LOADING',
  Completed = 'COMPLETED',
  Error = 'ERROR',
  LoadingMore = 'LOADING_MORE',
}

export interface Message {
  uuid: string;
  content: string;
  sentAt?: any;
  readAt?: Date;
  conversationUuid: string;
  senderUuid: string;
  receiverUuid: string;
  messageResources: MessageResource[];
}

export interface ResourceToAdd {
  id: number;
  name: string;
  image: string;
  uniqueKey: string;
  resourceType: string;
  selected: boolean | undefined;
}

export interface NewMessage {
  chatMessage: string;
  resourcesToAdd: ResourceToAdd[];
  conversationUuid: string;
  senderUuid: string;
  receiverUuid: string;
}
